export default { sha: '1711b1ee60fb8f96508db5aa6671a6de193d7bf3', buildNumber: 'undefined' }
